<template>
  <!-- Plain wrapper to be able to apply styles using container queries -->
  <div class="@container">
    <div
      class="@[224px]:px-3 px-2.5 flex-wrap py-2 bg-surface-hover flex flex-row rounded-lg @[224px]:justify-between gap-1 @[224px]:gap-0"
    >
      <div class="gap-3 shrink-0 flex flex-row items-center">
        <Icon icon="mdi:translate" class="text-icon size-5 @[224px]:size-6" />

        <span
          class="text-[13px] font-medium text-text-secondary hidden @[224px]:inline-block"
        >
          <span class="hidden @[250px]:inline-block">
            {{ $t("channel.translation.auto.label") }}
            {{
              translationStore.autoTranslateOn
                ? $t("channel.translation.auto.status.on")
                : $t("channel.translation.auto.status.off")
            }}
          </span>
          <span class="@[224px]:inline-block @[250px]:hidden">
            {{ $t("channel.translation.auto.label") }}
          </span>
        </span>
      </div>

      <button
        class="relative text-[13px] text-text-brand hover:text-icon-hover"
        :disable="translationStore.updatingAutoTranslate"
        @click="translationStore.showAutoTranslateConfirmation = true"
      >
        <span :class="{ invisible: translationStore.updatingAutoTranslate }">
          <span class="hidden @[224px]:inline-block">
            {{
              $t("channel.translation.auto.button.short", {
                state: buttonState,
              })
            }}
          </span>
          <span class="@[224px]:hidden">
            {{
              $t("channel.translation.auto.button.long", { state: buttonState })
            }}
          </span>
        </span>
        <span
          v-if="translationStore.updatingAutoTranslate"
          class="loading loading-spinner loading-sm absolute inset-0 m-auto"
        />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useTranslationStore } from "@/stores/translation.store";
import { Icon } from "@iconify/vue";
import { useI18n } from "vue-i18n";

const translationStore = useTranslationStore();
const { t } = useI18n();

const buttonState = computed(() => {
  return !translationStore.autoTranslateOn
    ? t("channel.translation.auto.status.on")
    : t("channel.translation.auto.status.off");
});
</script>
